/*
 * Public API Surface of shared
 */

export { provideNovaPortalLib } from './src/lib/nova-portal-lib.providers';
export * from './src/lib/nova-portal-lib-config.interface';
export * from './src/lib/nova-portal-lib-config.service';
export * from './src/lib/nova-portal-lib-config.token';
export * from './src/lib/notification.service';
export * from './src/lib/user-defaults.service';
export * from './src/lib/device-permission/device-permission.service';
export * from './src/lib/device-permission/utils/detect-browser-name';
export * from './src/lib/errors/not-found.error';
export * from './src/lib/errors/permission-denied.error';
export * from './src/lib/errors/timeout.error';
export * from './src/lib/errors/unknown-user.error';
export * from './src/lib/i18n/i18n.service';
export * from './src/lib/theme/theme.service';
export * from './src/lib/utils/uuid.service';
export * from './src/lib/utils/array.utils';
export * from './src/lib/utils/param-validation';
export * from './src/lib/utils/sort.helper';
export * from './src/lib/utils/typescript-ext';
export * from './src/lib/utils/url.helper';
